// extracted by mini-css-extract-plugin
module.exports = {"chargeSummary":"dN","totalBeforeTax":"eN","orderTotalRow":"fN"};